import React from 'react';
import SEO from '@/components/SEO';
import Hero from '../components/Hero';
import Services from '../components/Services';
import WhyChooseUs from '../components/WhyChooseUs';
import EMICalculator from '../components/EMICalculator';
import { Button } from '../components/ui/button';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <>
      <SEO
        title="AssetWise Business Consultants - Loans, Real Estate & Legal Advisory"
        description="Your trusted partner for loans, real estate, and legal advisory services. 40+ years in banking and 100 years cumulative expertise. Home loans from 7.25% p.a."
        path="/"
        keywords="home loan Mira Road, business loan Thane, loan consultant Mumbai, real estate consultant, legal advisory, loan against property"
      />
      
      <Hero />
      
      {/* Services Overview */}
      <Services />
      
      {/* EMI Calculator */}
      <EMICalculator />
      
      {/* Why Choose Us */}
      <WhyChooseUs />
      
      {/* CTA Section for Detailed Pages */}
      <section className="py-16 bg-gradient-to-br from-cyan-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-8">
            {/* Loans CTA */}
            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow border border-cyan-100">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Explore Our Loan Products</h3>
              <p className="text-gray-600 mb-6">
                From home loans to corporate financing, discover our comprehensive range of loan solutions with competitive rates.
              </p>
              <Link to="/loans">
                <Button className="bg-gradient-to-r from-cyan-500 to-teal-600 hover:from-cyan-600 hover:to-teal-700 text-white">
                  View All Loans
                  <ArrowRight className="ml-2 w-4 h-4" />
                </Button>
              </Link>
            </div>
            
            {/* About CTA */}
            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow border border-cyan-100">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Learn About Our Team</h3>
              <p className="text-gray-600 mb-6">
                Meet our experienced leadership team with decades of expertise in banking, real estate, and financial services.
              </p>
              <Link to="/about">
                <Button className="bg-gradient-to-r from-cyan-500 to-teal-600 hover:from-cyan-600 hover:to-teal-700 text-white">
                  About Us
                  <ArrowRight className="ml-2 w-4 h-4" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
